import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Button, Icon } from "rbx";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { downloadCSV } from "../../utils";

const ActionButtons = ({
  onAddClick,
  size,
  filters,
  setFilters,
  setModalOpen,
  FilterComponent,
  onAddBatchClick,
  client,
  name,
  query,
  columns,
  where,
  readOnly,
  onCloseBatchClick
}) => (
  <div className="page-head-end">
    <Field kind="group">
      {filters?.BatchNo && filters.Status && Object.keys(filters)?.length <= 2 && (
        <Control>
          <Button
            color="warning"
            disabled={readOnly}
            size={size}
            onClick={onCloseBatchClick}
          >
            <Icon>
              <FontAwesomeIcon icon="circle" />
            </Icon>
            <span>Close Batch</span>
          </Button>
        </Control>
      )}
      <Control>
        <Button
          color="link"
          disabled={readOnly}
          size={size}
          onClick={onAddBatchClick}
        >
          <Icon>
            <FontAwesomeIcon icon="certificate" />
          </Icon>
          <span>New Batch</span>
        </Button>
      </Control>
      <Control>
        <Button
          color="danger"
          size={size}
          onClick={() =>
            setModalOpen(
              true,
              <FilterComponent
                filters={filters}
                onClose={() => setModalOpen(false)}
                onFilter={setFilters}
              />
            )
          }
        >
          <Icon>
            <FontAwesomeIcon icon="filter" />
          </Icon>
          <span>Filter</span>
        </Button>
      </Control>
      <Control>
        <Button
          color="primary"
          size={size}
          onClick={() =>
            downloadCSV(
              client,
              {
                query,
                where: where ? { ...where } : { ...filters }
              },
              name,
              columns
            )
          }
        >
          <Icon>
            <FontAwesomeIcon icon="file-export" />
          </Icon>
          <span>Export</span>
        </Button>
      </Control>
      <Control>
        <Button
          color="success"
          disabled={readOnly}
          size={size}
          onClick={onAddClick}
        >
          <Icon>
            <FontAwesomeIcon icon="plus" />
          </Icon>
          <span>Add</span>
        </Button>
      </Control>
    </Field>
  </div>
);

ActionButtons.propTypes = {
  name: PropTypes.string,
  size: PropTypes.string,
  onAddClick: PropTypes.func,
  setFilters: PropTypes.func,
  setModalOpen: PropTypes.func,
  query: PropTypes.object,
  filters: PropTypes.object,
  client: PropTypes.object,
  FilterComponent: PropTypes.node,
  columns: PropTypes.array,
  where: PropTypes.object,
  readOnly: PropTypes.bool,
  onAddBatchClick: PropTypes.func,
  onCloseBatchClick: PropTypes.func
};

export default ActionButtons;
